import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["$app", "name", "children", "snmp_id"];
/* eslint-disable react/require-default-props */
import React from 'react';
import { inject } from 'mobx-react';
import Link from 'core/components/Link';
// Component to create a link to a device or its interface based on the provided props
// Avoid rendering device link to interfaces/tenant if the user is MKP
var DeviceLink = function DeviceLink(_ref) {
  var $app = _ref.$app,
    name = _ref.name,
    children = _ref.children,
    snmp_id = _ref.snmp_id,
    rest = _objectWithoutProperties(_ref, _excluded);
  if ($app.isSubtenant) {
    return children || name;
  }
  var path = "/v4/infrastructure/devices/".concat(name);
  if (snmp_id) {
    path += "/interfaces/".concat(snmp_id);
  }
  return /*#__PURE__*/React.createElement(Link, _extends({
    to: path
  }, rest), children || name);
};
export default inject('$app')(DeviceLink);